(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-holster-details"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    let findYourDeviceButton = document.querySelector('.product-holster-details .find-your-device__actions');
    findYourDeviceButton && findYourDeviceButton.remove();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    let mobileZoomIcon = document.querySelector('.zoom-icon__wrapper.mobile-icon');
    mobileZoomIcon?.addEventListener('click', () => {
      document.querySelector('.product-media-container[aria-hidden="false"]')?.click();
    });

    const thumbnails = document.querySelectorAll('.dialog-thumbnails-list__thumbnail');
    let zoomThumbnailPrevNextButtons = document.querySelectorAll('.dialog-thumbnails-list__scroll-hint-button');
    zoomThumbnailPrevNextButtons.forEach((element) => {
      element.addEventListener('click', () => {
        const current = document.querySelector('.dialog-thumbnails-list__thumbnail[aria-selected="true"]');

        if (!current) return;

        const thumbnailsArray = Array.from(thumbnails);
        const currentIndex = thumbnailsArray.indexOf(current);

        let newIndex;
        const direction = element.classList.contains('dialog-thumbnails-list__scroll-hint-next') ? 'next' : 'prev';

        if (direction === 'next') {
          newIndex = (currentIndex + 1) % thumbnailsArray.length; // loop forward
        } else if (direction === 'prev') {
          newIndex = (currentIndex - 1 + thumbnailsArray.length) % thumbnailsArray.length; // loop backward
        }

        // Remove current selection
        current.setAttribute('aria-selected', 'false');

        // Set new selection
        thumbnailsArray[newIndex].setAttribute('aria-selected', 'true');

        // Optional: focus the new selected element
        thumbnailsArray[newIndex].focus();
        thumbnailsArray[newIndex].click();
      });
    });

    let zoomDirectionsButtons = document.querySelectorAll('.zoom-image-directions-arrow-wrapper .directions-arrow');
    zoomDirectionsButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (window.innerWidth >= 768) {
          let dialog = button.closest('dialog');
          if (!dialog) return;
          const scrollAmount = 100;
          switch (button.classList[1]) {
            case 'arrow-up':
              dialog.scrollBy({ top: -scrollAmount, behavior: 'smooth' });
              break;
            case 'arrow-down':
              dialog.scrollBy({ top: scrollAmount, behavior: 'smooth' });
              break;
            case 'arrow-left':
              dialog.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
              break;
            case 'arrow-right':
              dialog.scrollBy({ left: scrollAmount, behavior: 'smooth' });
              break;
            default:
              return; // If it's an unrecognized button, do nothing
          }
        } else {
          let activeMediaContainer = document.querySelector('.dialog-thumbnails-list__thumbnail[aria-selected="true"]');
          let activeMediaId = activeMediaContainer?.dataset.id;
          const wrapper = document.querySelector(
            `.dialog-zoomed-gallery.list-unstyled [data-id="${activeMediaId}"] drag-zoom-wrapper`
          );
          switch (button.classList[1]) {
            case 'arrow-up':
              wrapper?.moveUp();
              break;
            case 'arrow-down':
              wrapper?.moveDown();
              break;
            case 'arrow-left':
              wrapper?.moveLeft();
              break;
            case 'arrow-right':
              wrapper?.moveRight();
              break;
            default:
              return; // If it's an unrecognized button, do nothing
          }
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pdp-sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    (() => {
    const stickyBar = document.querySelector('.pdp-sticky-add-to-cart-wrapper');
    const addToCartComponent = document.querySelector('add-to-cart-component');

    const toggleStickyBar = (isVisible) => {
      if (isVisible) {
        stickyBar.classList.remove('is-visible');
      } else {
        stickyBar.classList.add('is-visible');
      }
    };

    if (stickyBar && addToCartComponent) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          toggleStickyBar(entry.isIntersecting);
        });
      });

      // Observe the add-to-cart-component
      observer.observe(addToCartComponent);

      // Check visibility on page load
      const rect = addToCartComponent.getBoundingClientRect();
      const isInViewport = rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
      toggleStickyBar(isInViewport);
    }
    document.body.addEventListener('click', (event) => {
      const stickyButton = event.target.closest('.pdp-sticky-add-to-cart-wrapper .add-to-cart-button-wrapper button');
      if (stickyButton) {
        console.log('Sticky Add to Cart button clicked!');

        // Find the main Add to Cart button
        const mainAddToCartButton = event.target.closest('.product-information').querySelector('product-form-component button[ref="addToCartButton"]');
        if (mainAddToCartButton) {
          // Trigger the main Add to Cart button click
          mainAddToCartButton.click();
        } else {
          console.error('Main Add to Cart button not found!');
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["promotions-text"] && !Shopify.designMode) return;
  try {
    (() => {
    document.querySelectorAll('.pdp-promo-details-wrapper').forEach(wrapper => {

      // Prevent double initialization
      if (wrapper.dataset.initialized === 'true') return;
      wrapper.dataset.initialized = 'true';

      const button = wrapper.querySelector('.pdp-promo-details-title-wrapper');
      const content = wrapper.querySelector('.pdp-promo-details');

      if (!button || !content) return;

      button.addEventListener('click', () => {
        const isOpen = button.classList.contains('active');

        if (isOpen) {
          content.style.height = '0px';
          button.classList.remove('active');
        } else {
          content.style.height = content.scrollHeight + 'px';
          button.classList.add('active');
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
